import '../less/reacard.less';
import Tabbox from "./tabbox";
import Navigation from "./navigation";
import Accordion from "./accordion";
import Textinput from "./textinput";
import Dropdown from "./dropdown";
import RichGallery from "./rich-gallery";
import Gallery from "./gallery";
import Form from "./form";
import Button from "./button";
import FocalBackground from "./focalbackground";
import Hero from "./hero";
import Scroller from "./lib/scroller";
import ImageSlider from "./image-slider";
import Icon from "./icon";
import Teaserslider from "./teaserslider";
import './filebrowser/filebrowser-web.jsx';
import './filebrowser/favorites-web';
import './search/search-web';
import './side-navigation/side-navigation-web';
import './wizard/wizard-web';
import './components/ConsentManagementBlock'

require('../assets/rea-card-logo-colored.svg')
require('../assets/rea-card-logo-colored-large.svg')
require('../assets/rea-card-logo-colored-medium.svg')
require('../assets/rea-card-logo-white.svg')

require.context("../assets/payment/", true, /^\.\/.*\.svg/);

window.reacard = {
    phraseConfig: {}
};

let initialized = false;

function initialize() {
    if (initialized) {
        return;
    }

    document.querySelectorAll('.product-slider').forEach((slider) => {
        try {
            new Scroller(slider);
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.image-slider').forEach((slider) => {
        try {
            new ImageSlider(slider);
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.teaser--slider').forEach((slider) => {
        try {
            new Teaserslider(slider);
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.navigation').forEach((navigation) => {
        try {
            new Navigation(navigation)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.tabBox--vertical').forEach((tabBox) => {
        try {
            new Tabbox(tabBox)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.tabBox--horizontal').forEach((tabBox) => {
        try {
            new Tabbox(tabBox)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.accordion').forEach((accordion) => {
        try {
            new Accordion(accordion)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.textInput').forEach((textInput) => {
        try {
            new Textinput(textInput)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.dropdown').forEach(dropdown => {
        try {
            new Dropdown(dropdown)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.rich_gallery').forEach(gallery => {
        try {
            new RichGallery(gallery)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.gallery').forEach(gallery => {
        try {
            new Gallery(gallery)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.pimcore_area_form').forEach(form => {
        try {
            new Form(form)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.button').forEach(button => {
        try {
            new Button(button)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('[data-focal-x]').forEach(focalbackground => {
        try {
            new FocalBackground(focalbackground)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.hero').forEach(hero => {
        try {
            new Hero(hero)
        } catch (e) {
            console.error(e);
        }
    })
    document.querySelectorAll('.icon').forEach(icon => {
        try {
            new Icon(icon)
        } catch (e) {
            console.error(e);
        }
    })

    initialized = true;
}

if (document.readyState === "interactive" || document.readyState === "complete") {
    initialize();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        initialize();
    })
}
